import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import SimpleMVPResults from '../components/search/SimpleMVPResults';

// MVP Search Page - Clean, accessible job search interface
// Focus: Core functionality with WCAG 2.1 AA compliance

const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.mode === 'light' ? '#f8f9fa' : '#1a1a1a',
  color: theme.palette.mode === 'light' ? '#333333' : '#ffffff',
  
  // Ensure proper color contrast
  '& *': {
    '&:focus': {
      outline: `3px solid ${theme.palette.mode === 'light' ? '#4d9fff' : '#66b3ff'}`,
      outlineOffset: '2px'
    }
  }
}));

const MVPSearchPage = () => {
  return (
    <PageContainer>
      <SimpleMVPResults />
    </PageContainer>
  );
};

export default MVPSearchPage;